import { Typography, Button,Box } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Box sx={{ textAlign: 'center', mt: 10 }}>
      <Typography variant="h3">404 - Page Not Found</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        The page you're looking for doesn't exist.
      </Typography>
      <Button 
        component={Link} 
        to="/" 
        variant="contained" 
        sx={{ mt: 3 }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;